<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                
          <h3 class="mb-0">
            {{ $t('message.add') }} {{ $t('message.compteRenduOperatoire') }}
          </h3>
        </div>
      </div>

      <div class="card-body p-0">

        <h3 class="text-center"> {{$t('message.infoConsultation')}}
        </h3>
        <b-form v-if="show">
          <b-container class="p-0">
            <!-- <div class="form-group col-md-12">
                <span class="obligatoire">*</span>
                <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                <autocomplete
                    :search="getEtablisssements"
                    placeholder="Rechercher l'établissement"
                    aria-label="Rechercher l'établissement"
                    :get-result-value="getValueEtablissement"
                    @submit="chooseEtablissement"
                ></autocomplete>
                <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
            </div> -->
            <b-row class="p-0">
                <b-col sm="12">
                    <span class="obligatoire">*</span>
                    <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                        <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                        <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                        <span v-if="errorshasField('activity_id')" style="color:red">
                            {{getErrorsField('activity_id')}}
                        </span>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group id="institution-group" :label="$t('message.etablissementIntervention')" label-for="etablissement_id">
                  <select id="etablissement_id" v-model="$v.form.etablissement_id.$model" @change="clearErrorField('etablissement_id')" class="form-control is-invalid retirerBordure" required>
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="'etablissement_id'+item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('etablissement_id')" class="invalid">{{ getErrorsField('etablissement_id') }} </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="typeIntervention-group"
                    :label="$t('message.typeIntervention')"
                    label-for="typeIntervention-propose"
                >
                  <b-form-input
                      id="occupation"
                      v-model="$v.form.type_intervention.$model"
                      :state="$v.form.type_intervention.$dirty ? !(errorshasField('type_intervention') || $v.form.type_intervention.$error) : null"
                      @focus="clearErrorField('profession')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('type_intervention')">
                    {{ getErrorsField('type_intervention') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="!$v.form.type_intervention.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="clinicalHistory-group"
                    :label="$t('message.clinicalHistory')"
                    label-for="clinicalHistory"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.histoire_clinique.$model"
                      :state="$v.form.histoire_clinique.$dirty ? !(errorshasField('histoire_clinique') || $v.form.histoire_clinique.$error) : null"
                      @focus="clearErrorField('histoire_clinique')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('histoire_clinique')">
                    {{ getErrorsField('histoire_clinique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="consultation-group"
                    :label="$t('message.dateIntervention')"
                    label-for="consultation"
                    description="">
                  <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.date_intervention.$model"></vue-ctk-date-time-picker>

                  <b-form-invalid-feedback v-if="!$v.form.date_intervention.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_intervention')">
                    {{ getErrorsField('date_intervention') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="chirugiens-group"
                    :label="$t('message.chirugiens')"
                    label-for="chirugiens"
                >
                  <select id="chirugiens" v-model="$v.form.chirugiens.$model"
                          @change="clearErrorField('chirugiens')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('contributeurs')" class="invalid">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                  <span class="invalid" v-if="$v.form.chirugiens.$error"  >
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="aide-group"
                    :label="$t('message.aide')"
                    label-for="aide"
                >
                  <select id="aide" v-model="$v.form.aides.$model"
                          @change="clearErrorField('aides')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('aides')" class="invalid">
                                    {{getErrorsField('aides')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="circulant-group"
                    :label="$t('message.circulant')"
                    label-for="circulant"
                >
                  <select id="circulant" v-model="$v.form.circulants.$model"
                          @change="clearErrorField('circulants')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('circulants')" class="invalid">
                                    {{getErrorsField('circulants')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="anesthesistes-group"
                    :label="$t('message.anesthesistes')"
                    label-for="anesthesistes"
                >
                  <select id="anesthesistes" v-model="$v.form.anesthesistes.$model"
                          @change="clearErrorField('anesthesistes')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('anesthesistes')" class="invalid">
                                    {{getErrorsField('anesthesistes')}}
                                    </span>
                  
                  <span class="invalid" v-if="$v.form.anesthesistes.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="typeAnesthesie-group"
                    :label="$t('message.typeAnesthesie')"
                    label-for="typeAnesthesie-propose"
                >
                  <b-form-input
                      id="typeAnesthesie"
                      v-model="$v.form.type_anesthesie.$model"
                      :state="$v.form.type_anesthesie.$dirty ? !(errorshasField('type_anesthesie') || $v.form.type_anesthesie.$error) : null"
                      @focus="clearErrorField('type_anesthesie')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('type_anesthesie')">
                    {{ getErrorsField('type_anesthesie') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.type_anesthesie.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="descriptionIntervention-group"
                    :label="$t('message.descriptionIntervention')"
                    label-for="descriptionIntervention"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.description.$model"
                      :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                      @focus="clearErrorField('description')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('description')">
                    {{ getErrorsField('description') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.description.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="traitementPostOperatoire-group"
                    :label="$t('message.traitementPostOperatoire')"
                    label-for="traitementPostOperatoire"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.traitement_post_operatoire.$model"
                      :state="$v.form.traitement_post_operatoire.$dirty ? !(errorshasField('traitement_post_operatoire') || $v.form.traitement_post_operatoire.$error) : null"
                      @focus="clearErrorField('traitement_post_operatoire')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('traitement_post_operatoire')">
                    {{ getErrorsField('traitement_post_operatoire') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.traitement_post_operatoire.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row class="justify-content-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.save') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import {mapGetters} from "vuex";
import _ from "lodash";
import moment from "moment";
import AppConfig from "@/constants/AppConfig";
import $ from "jquery";
import {minLength, required} from "vuelidate/lib/validators";
import SlimSelect from "slim-select";
import axios from "axios";
import Multiselect from 'vue-multiselect'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  name: "Add",
  components: {
    editor: Editor,
    Multiselect,
    Autocomplete
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "file",
      "institutions",
      "userInstitutions",
      "errors",
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPraticienRole']),

    mMedicalFile: function () {
      return (_.isUndefined(this.file) || _.isNull(this.file)) ? [] : this.file;
    },

    mInstitutions: function () {
      let iArray = [];

      _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
        let i = {};

        i.nom = institution.name;
        i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
        i.date = moment(institution.created_at).format('DD-MM-YYYY');
        i.id = institution.id;
        i.slug = institution.slug;

        iArray.push(i);
      });

      return iArray;
    },


    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
      }
    },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = doctor.user.id;

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data() {
    return {
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      file_id: this.$route.params.file,

      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },
      missions: [],
      form: {
        etablissement_id:"  ",
        dossier_medical_id:"",
        etablissement_id:null,
        type_intervention:"",
        histoire_clinique:"",
        date_intervention:"",
        chirugiens:[],
        activity_id:'',
        aides:[],
        circulants:[],
        anesthesistes:[],
        type_anesthesie:"",
        description:"",
        traitement_post_operatoire:"",
      },

      show: true,
    }
  },

  methods: {
    getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
            },
        getEtablisssements(input){
            return new Promise(resolve => {
                if (input.length < 2) {
                return resolve([])
                }
                fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                .then(res => res.json())
                .then(res => {
                    resolve(res.etablissements)
                }).catch(error => {
                    console.log('error ', error);
                })
            })
        },
        getValueEtablissement(result) {
            return result.name
        },
        chooseEtablissement(result) {
            this.form.etablissement_id = result.id;
        },
    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },


    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', {args: args});
    },

    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },

    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getInstitutions', {args: args});
    },

    notEmpty(item) {
      return item.length > 0;
    },

    getMedicalFile() {
      let args = {
        file: this.file_id
      };

      this.$store.dispatch("getMedicalFile", {args});
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      if (!this.$v.form.$invalid){
        let args = this.$v.form.$model;
        args.etablissement_id= this.form.etablissement_id;
        args.chirugiens = _.map(this.form.chirugiens).join(', ');
        args.activity_id = JSON.stringify(this.form.activity_id);
        args.aides = _.map(this.form.aides).join(', ');
        args.anesthesistes = _.map(this.form.anesthesistes).join(', ');
        args.circulants = _.map(this.form.circulants).join(', ');
        args.dossier_medical_id = this.file.id;
        args.date_intervention = moment(this.form.date_intervention).format('YYYY-MM-DD HH:mm');

        let successMessage = this.$i18n.t('message.compteRendu.operatoireCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createcompteRendu', {args: args, errorMessages, successMessage})

      }


        // let successMessage = this.$i18n.t('message.generalConsultationCreated');
        // let errorMessages = {
        //   generic: this.$i18n.t('message.genericError'),
        //   error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        // };
        //
        //
        // this.$store.dispatch('createGeneralConsultation', {args: args, errorMessages, successMessage})
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations: {
    form: {
      activity_id:{
                    required
                },
      etablissement_id: {required},
      dossier_medical_id:{},
      type_intervention:{required},
      histoire_clinique:{required},
      date_intervention:{required},
      chirugiens:{required},
      aides:{},
      circulants:{},
      anesthesistes:{required },
      type_anesthesie:{required},
      description:{required},
      traitement_post_operatoire:{required},
    },

  },


  mounted() {
    this.getGroupeActivites();
    // Fetch control doctor list
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();

    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();
    // Retrieve list of medical documents
    this.getMedicalFile();


    this.$v.form.date_intervention.$model = this.today;

    new SlimSelect({
      select: '#institution',
      placeholder: 'Select institution',
      limit: 1
    });

    var chirugiens = new SlimSelect({
      select: '#chirugiens',
      placeholder: 'Select chirugiens',
      addable: function (value) {
        if (chirugiens.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var aide = new SlimSelect({
      select: '#aide',
      placeholder: 'Select aide',
      addable: function (value) {
        if (aide.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var circulant = new SlimSelect({
      select: '#circulant',
      placeholder: 'Select circulant',
      addable: function (value) {
        if (circulant.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var anesthesistes = new SlimSelect({
      select: '#anesthesistes',
      placeholder: 'Select circulant',
      addable: function (value) {
        if (anesthesistes.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });


    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

  }
}
</script>

<style scoped>
.invalid {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f5365c
}
</style>